var throttle = require('./throttle');
var debounce = require('./debounce');

module.exports = {
	throttle: throttle,
	debounce: debounce
};



//////////////////
// WEBPACK FOOTER
// ./~/throttle-debounce/index.js
// module id = 290
// module chunks = 0